import { render, staticRenderFns } from "./RbxFileUpload.vue?vue&type=template&id=0e244792&"
import script from "./RbxFileUpload.vue?vue&type=script&lang=js&"
export * from "./RbxFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./RbxFileUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RbxFileUpload.vue"
export default component.exports